﻿<template>
	<div class="ModalEditApplication">
		<div
			class="modal-container"
			id="edit-application-modal"
			:style="{ zIndex: '9999999999' }"
		>
			<div
				class="modal-header"
				:style="{ borderBottom: `1px solid ${theme.mainTextColor}` }"
			>
				{{ title }}
			</div>
			<div class="modal-body">
				<div
					v-if="Array.isArray(info)"
					class="modal-body-info"
					:style="$grid('1')"
				>
					<span
						v-for="(i, index) in info"
						:key="index"
						>{{ i }}</span
					>
				</div>
				<div
					v-else
					class="modal-body-info"
				>
					{{ info }}
				</div>
			</div>
			<div
				class="modal-footer"
				:style="{ borderTop: `1px solid ${theme.mainTextColor}` }"
			>
				<button
					class="button"
					:style="{
						background: theme.successButtonColor,
						color: theme.successButtonTextColor,
					}"
					@click="keepCurrentValue()"
				>
					{{ currentValueText }}
				</button>
				<button
					class="button"
					:style="{
						background: theme.successButtonColor,
						color: theme.successButtonTextColor,
					}"
					@click="keepAlternativeValue()"
				>
					{{ alternativeValueText }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import $modal from '@core/services/modal';
	import ApplicationsSettingsLoader from '@core/classes/Applications/ApplicationsSettingsLoader';

	export default {
		name: 'modalConfirmCustomerApplicationInfo',
		props: ['modal'],
		data() {
			return {
				title: 'Information',
				info: null,
				currentValueText: null,
				alternativeValueText: null,
				additionalData: null,
				theme: null,
			};
		},
		computed: {},
		created() {
			this.info = this.modal.passedData.info;
			this.currentValueText = this.modal.passedData.currentValueText;
			this.alternativeValueText = this.modal.passedData.alternativeValueText;
			this.additionalData = this.modal.passedData.additionalData;
			if (this.modal.passedData.title) {
				this.title = this.modal.passedData.title;
			}
			this.theme = ApplicationsSettingsLoader.ApplicationSettings.theme;
		},
		methods: {
			keepAlternativeValue() {
				$modal.close(this.additionalData);
			},
			keepCurrentValue() {
				if (typeof this.modal.passedData.cancelFunction == 'function') {
					this.modal.passedData.cancelFunction();
				}
				$modal.cancel();
			},
		},
		components: {},
	};
</script>
<style>
	.ModalEditApplication {
		margin: auto;
		display: flex;
		justify-content: center;
		width: 100%;
		max-width: 300px;
		transition: max-width 1s ease;
	}

	.ModalEditApplication .modal-container#edit-application-modal {
		width: 90%;
	}

	.ModalEditApplication .modal-header {
		text-align: center;
		text-transform: capitalize;
		display: flex;
		justify-content: center;
	}

	.ModalEditApplication .modal-footer {
		justify-content: space-between;
	}

	.ModalEditApplication .modal-footer .button {
		padding: 5px 10px;
		min-width: 40%;
	}

	.ModalEditApplication .modal-body .input-component {
		border-bottom: none;
		border-bottom-style: unset;
	}

	.ModalEditApplication textarea {
		width: 100%;
		height: 100px;
		padding: 5px 5px 5px 10px;
		transition: height 1s ease;
	}

	@media screen and (min-width: 280px) {
		.ModalEditApplication .modal-footer .button {
			padding: 10px 20px;
			min-width: 100px;
		}
	}

	@media screen and (min-width: 375px) {
		.ModalEditApplication {
			max-width: 400px;
		}

		.ModalEditApplication .modal-footer {
			justify-content: space-evenly;
		}
	}

	@media screen and (min-width: 768px) {
		.ModalEditApplication {
			max-width: 500px;
		}

		.ModalEditApplication .modal-footer .button {
			padding: 15px 30px;
		}

		.ModalEditApplication textarea {
			width: 100%;
			height: 150px;
		}
	}
</style>
